import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsPH: CultureInfo = {
  name: 'es-PH',
  displayName: 'español (Filipinas)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-PH',
  parent: CultureInfoEs
};
